export enum SalesChannelEnum {
  WEB = 0,
  STAFF = 1,
  SPECIAL = 2,
  PACKAGE = 3,
}